document.addEventListener('DOMContentLoaded', () => {
  const SECONDS = 4; // change speed here
  const SELECTOR = '[data-autoplay-slider] slider-component';

  document.querySelectorAll(SELECTOR).forEach(init);

  function init(comp) {
    const root = comp.closest('[data-autoplay-slider]');
    const nextBtn = comp.querySelector('.slider-button--next');
    if (!nextBtn) return;

    const intervalMs = parseInt(root?.dataset?.interval || SECONDS * 1000, 10);
    let timer = null, hovering = false, visible = true;

    const play = () => {
      if (timer || hovering || !visible) return;
      timer = setInterval(() => {
        const btn = comp.querySelector('.slider-button--next'); // re-query in case of rerender
        if (btn) btn.click();
      }, intervalMs);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    // Pause on hover
    root.addEventListener('mouseenter', () => { hovering = true; stop(); });
    root.addEventListener('mouseleave', () => { hovering = false; play(); });

    // Pause when not in viewport
    const io = new IntersectionObserver(([e]) => {
      visible = !!e?.isIntersecting;
      visible ? play() : stop();
    }, { threshold: 0.2 });
    io.observe(root);

    // Pause when tab hidden
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));

    play();
  }
});
